import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { BONOS } from '../data/content';
export function Bonos() {
  return <section id="bonos" className="w-full bg-ink-soft px-5 py-16 sm:px-8 sm:py-24" data-id="element-15" data-mp="2ha79knnspx56">
      <div className="mx-auto max-w-6xl" data-id="element-16" data-mp="2lc27rjafjueq">
        <div className="max-w-3xl" data-id="element-17" data-mp="2q5eqxdwcb903">
          <SectionLabel data-id="element-18" data-mp="2q6g53r8nkbm1">6 Bonos — siempre incluidos</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-white sm:text-5xl" data-id="element-19" data-mp="2v4rg45aoos5u">
            🎁 Para los momentos que no avisan
          </h2>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="352fdl2zocdrp">
          {BONOS.map(bono => <li key={bono.numero} className="flex h-full flex-col rounded-3xl border border-ink-line bg-ink p-6" data-id="element-21" data-mp="39497msfd6jiw">
              <div className="flex items-start justify-between gap-3" data-id="element-22" data-mp="1aq7my1udyj1q">
                <span className="font-display text-[10px] font-semibold uppercase tracking-[0.28em] text-violeta-300" data-id="element-23" data-mp="1eqhsxei6h9gl">
                  {bono.numero}
                </span>
                <span className="text-2xl" aria-hidden="true" data-id="element-24" data-mp="39d12j2qccmqd">
                  {bono.emoji}
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-bold leading-snug text-white" data-id="element-25" data-mp="34eppyk8nvy4g">
                {bono.titulo}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-violeta-100/70" data-id="element-26" data-mp="xhgano384kt">
                {bono.descripcion}
              </p>
              <p className="mt-5 flex items-center gap-3 border-t border-ink-line pt-4 text-sm" data-id="element-27" data-mp="3s4tsspe0ztue">
                <span className="text-violeta-100/50 line-through" data-id="element-28" data-mp="3n3o3l1jkqopm">{bono.valor}</span>
                <span className="inline-flex items-center gap-1 font-display font-bold text-violeta-300" data-id="element-29" data-mp="3i6e22niwumlf">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-30" data-mp="2bqlk9yq3bl1r" />
                  GRATIS
                </span>
              </p>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center gap-2 rounded-3xl border border-violeta-600/30 bg-ink p-7 text-center" data-id="element-31" data-mp="yra1g5trx9ln">
          <p className="text-sm uppercase tracking-[0.22em] text-violeta-300" data-id="element-32" data-mp="12rkc3vsigo6u">
            Valor total bonos
          </p>
          <p className="font-display text-4xl font-extrabold text-white line-through decoration-red-400/70 decoration-2" data-id="element-33" data-mp="oskrcz84ctfy">
            $62.000 ARS
          </p>
          <p className="font-display text-lg font-bold text-violeta-300" data-id="element-34" data-mp="f2re7tsbw69l">
            → GRATIS con tu MegaPack
          </p>
        </div>
      </div>
    </section>;
}